//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

// Escapes regex metacharacters so the string can be safely embedded in a RegExp pattern.
export function escapeRegexSpecialChars(string: string): string {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
